import React, { useEffect, useState } from "react";
import {md5} from "js-md5";
import IconHeading from "../../Icons/IconHeading";
import GoogleMapsAPILoader from "../../shared/GoogleMapsAPILoader/GoogleMapsAPILoader";
import apiGet from "../../shared/api/apiGet";
import {
  ENDPOINT_BOOKING_SETUP,
  ENDPOINT_CONFIGS, ENDPOINT_PROMO_CODE,
  ENDPOINT_SAVE_DRAFT,
  ENDPOINT_SEARCH
} from "../../shared/consts/apiConsts";
import {INBOUND, ONE_WAY_TRIP, OUTWARD, RETURN_TRIP} from "../../shared/consts/bookingConsts";
import TripSection from "../../shared/BookingPage/TripSection/TripSection";
import apiPost from "../../shared/api/apiPost";
import TripSelector from "../../shared/BookingPage/TripSelector/TripSelector";
import ExtraRequirements from "../../shared/BookingPage/ExtraRequirements/ExtraRequirements";
import moneyFormat from "../../shared/MoneyFormat/moneyFormat";
import Loading from "../../shared/Loader/Loading";
import duplicatePax from "../../shared/duplicatePax/duplicatePax";
import validatePax from "../../shared/ValidatePax/validatePax";
import dataLayerHandler, {
  PAX_EMAIL,
  PAX_NAME, PAX_PHONE,
  TRIP_DATE,
  TRIP_DROPOFF,
  TRIP_PAX,
  TRIP_PICKUP, TRIP_RETURN_DATE,
  TRIP_RETURN_DROPOFF,
  TRIP_RETURN_PAX,
  TRIP_RETURN_PICKUP, TRIP_RETURN_SELECT, TRIP_RETURN_TERMINAL, TRIP_SAVE_DRAFT,
  TRIP_SEARCH, TRIP_SELECT,
  TRIP_SUBMIT,
  TRIP_TERMINAL,
  TRIP_TIME, TRIP_TOTAL
} from "../../shared/dataLayer/dataLayerHandler";
import participantString from "../../shared/participantString/participantString";

const BookingPage = () => {

  const [configs, setConfigs] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(null);
  const [lateFee, setLateFee] = useState(null);
  const [dateSearching, setDateSearching] = useState(false);
  const [priceSearching, setPriceSearching] = useState(false);
  const [promoApplying, setPromoApplying] = useState(false);
  const [finalSubmitting, setFinalSubmitting] = useState(false);

  const [hash, setHash] = useState(null);

  const [canSubmit, setCanSubmit] = useState(false);
  const [bookingType, setBookingType] = useState(ONE_WAY_TRIP);

  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [passengers, setPassengers] = useState('');
  const [promo, setPromo] = useState('');

  // outward data
  const [outStartLat, setOutStartLat] = useState('');
  const [outStartLng, setOutStartLng] = useState('');
  const [outStartAddress, setOutStartAddress] = useState('');
  const [outAvailable, setOutAvailable] = useState(null);

  const [outEndLat, setOutEndLat] = useState('');
  const [outEndLng, setOutEndLng] = useState('');
  const [outEndAddress, setOutEndAddress] = useState('');

  const [outPax, setOutPax] = useState([]);
  const [outPaxError, setOutPaxError] = useState(null);
  const [outDate, setOutDate] = useState(null);

  const [outAirport, setOutAirport] = useState(false);
  const [outAirline, setOutAirline] = useState(null);
  const [outFlightNumber, setOutFlightNumber] = useState(null);
  const [outFlightTime, setOutFlightTime] = useState(null);
  const [outTerminal, setOutTerminal] = useState(null);
  const [outNoFlight, setOutNoFlight] = useState(false);

  const [outPricing, setOutPricing] = useState(null);


  // inward data
  const [inStartLat, setInStartLat] = useState('');
  const [inStartLng, setInStartLng] = useState('');
  const [inStartAddress, setInStartAddress] = useState('');
  const [inAvailable, setInAvailable] = useState(null);

  const [inEndLat, setInEndLat] = useState('');
  const [inEndLng, setInEndLng] = useState('');
  const [inEndAddress, setInEndAddress] = useState('');

  const [inPax, setInPax] = useState([]);
  const [inPaxError, setInPaxError] = useState(null);
  const [inDate, setInDate] = useState(null);

  const [company, setCompany] = useState([]);
  const [voucher, setVoucher] = useState(null);

  const [inAirport, setInAirport] = useState(false);
  const [inAirline, setInAirline] = useState(null);
  const [inFlightNumber, setInFlightNumber] = useState(null);
  const [inFlightTime, setInFlightTime] = useState(null);
  const [inTerminal, setInTerminal] = useState(null);
  const [inNoFlight, setInNoFlight] = useState(false);

  const [inPricing, setInPricing] = useState(null);

  const [selectedOutbound, setSelectedOutbound] = useState(null);
  const [selectedInbound, setSelectedInbound] = useState(null);

  const [outSelectionLoading, setOutSelectionLoading] = useState(null);
  const [inSelectionLoading, setInSelectionLoading] = useState(null);

  const [customErrorMessage, setCustomErrorMessage] = useState(null);

  const [controller, setController] = useState(undefined);

  useEffect(() => {
    apiGet(ENDPOINT_CONFIGS).then((results) => {
      setLoading(false);
      setConfigs(results);
      setOutPax(duplicatePax(results.types));
      setInPax(duplicatePax(results.types));
    });
  }, []);

  // useEffect(() => {
  //   calculateCanSubmit();
  // }, [bookingType]);

  useEffect(() => {
    if (configs) {
      const session = configs.session;

      setEmail(configs.email);
      setFullName(configs.name);
      setPhone(configs.phone);

      if (!session || !session.trips) {
        return;
      }

      setBookingType(session.type);
      if (session.trips[0]) {
        console.log('IS AIRPORT', session.trips[0].is_airport);
        setOutDate(session.trips[0].date);
        setOutStartLng(session.trips[0].start[0]);
        setOutStartLat(session.trips[0].start[1]);
        setOutStartAddress(session.trips[0].start[2]);
        setOutEndLng(session.trips[0].end[0]);
        setOutEndLat(session.trips[0].end[1]);
        setOutEndAddress(session.trips[0].end[2]);
        setOutPax(session.trips[0].pax);
        setOutAvailable(session.trips[0].matched);
        setOutAirport(session.trips[0].is_airport);
        setOutAirline(session.trips[0].airline);
        setOutFlightNumber(session.trips[0].flight_number);
        setOutFlightTime(session.trips[0].flight_time);
        setOutTerminal(session.trips[0].terminal);
      }
      if (session.type === RETURN_TRIP && session.trips[1]) {
        console.log('IS AIRPORT', session.trips[1].is_airport);
        setInDate(session.trips[1].date);
        setInStartLng(session.trips[1].start[0]);
        setInStartLat(session.trips[1].start[1]);
        setInStartAddress(session.trips[1].start[2]);
        setInEndLng(session.trips[1].end[0]);
        setInEndLat(session.trips[1].end[1]);
        setInEndAddress(session.trips[1].end[2]);
        setInPax(session.trips[1].pax);
        setInAvailable(session.trips[1].matched);
        setInAirport(session.trips[1].is_airport);
        setInAirline(session.trips[1].airline);
        setInFlightNumber(session.trips[1].flight_number);
        setInFlightTime(session.trips[1].flight_time);
        setInTerminal(session.trips[1].terminal);
      }
    }
  }, [configs]);

  useEffect(() => {
    makeSearchHash();
  }, [outStartLat, outEndLng, outPax, outDate, inStartLat, inEndLng, inPax, inDate]);

  useEffect(() => {
    performSearch();
  }, [hash]);

  // useEffect(() => {
  //   // if (selectedOutbound) {
  //   //   setOutSelectionLoading(selectedOutbound.activity);
  //   // }
  //   setUpBooking(false);
  // }, [selectedOutbound]);

  useEffect(() => {
    // if (selectedInbound) {
    //   setInSelectionLoading(selectedInbound.activity);
    // }
    setUpBooking(false);
  }, [selectedInbound, selectedOutbound]);


  const updateBookingType = (type) => {
    setInDate(null);
    setInStartLng(type === RETURN_TRIP ? outEndLng : '');
    setInStartLat(type === RETURN_TRIP ? outEndLat : '');
    setInStartAddress(type === RETURN_TRIP ? outEndAddress : '');
    setInEndLng(type === RETURN_TRIP ? outStartLng : '');
    setInEndLat(type === RETURN_TRIP ? outStartLat : '');
    setInEndAddress(type === RETURN_TRIP ? outStartAddress : '');
    setInPax(type === RETURN_TRIP ? duplicatePax(outPax) : []);
    setInAvailable(null);
    setInAirport(type === RETURN_TRIP ? outAirport : false);
    setInAirline('');
    setInFlightNumber('');
    setInFlightTime('');
    setInTerminal('');
    setInPricing(null);
    setSelectedInbound(null);
    // setSelectedOutbound(null);
    setBookingType(type);
  }

  const handleAbortController = () => {
    if (controller) {
      controller.abort();
    }
    const ctrl = new AbortController();
    setController(ctrl);
    return ctrl;
  }

  const makeSearchHash = () => {
    const data = {
      outward: null,
      inward: null
    }
    if (outStartLat && outEndLng && outPax && outDate) {
      data.outward = [outStartLat, outEndLng, outPax, outDate]
    }
    if (bookingType === RETURN_TRIP && inStartLat && inEndLng && inPax && inDate) {
      data.inward = [inStartLat, inEndLng, inPax, inDate]
    }

    if (data.outward || data.inward) {
      const str = JSON.stringify(data);
      setHash(md5(str));
    }
  }

  const performSearch = () => {
    const post = {
      type: bookingType,
      outward: null,
      inward: null
    };

    if (outStartLat && outEndLng && outPax && outDate) {
      post.outward = {
        start: [outStartLng, outStartLat, outStartAddress],
        end: [outEndLng, outEndLat, outEndAddress],
        date: outDate,
        pax: outPax,
        is_airport: outAirport,
        airline: outAirline,
        flight_number: outFlightNumber,
        flight_time: outFlightTime,
        terminal: outTerminal,
      }

      const paxValidate = validatePax(outPax);
      setOutPaxError(!paxValidate[0] ? paxValidate[1] : null);
    }

    if (bookingType === RETURN_TRIP && inStartLat && inEndLng && inPax && inDate) {
      post.inward = {
        start: [inStartLng, inStartLat, inStartAddress],
        end: [inEndLng, inEndLat, inEndAddress],
        date: inDate,
        pax: inPax,
        is_airport: inAirport,
        airline: inAirline,
        flight_number: inFlightNumber,
        flight_time: inFlightTime,
        terminal: inTerminal
      }

      const paxValidate = validatePax(inPax);
      setInPaxError(!paxValidate[0] ? paxValidate[1] : null);
    }

    if (post.outward) {
      setDateSearching(true);
      apiPost(
        ENDPOINT_SEARCH,
        post,
        null,
        handleAbortController()
      ).then((response) => {
        if (response) {
          setOutAvailable(false);
          setInAvailable(false);
          setOutAirport(false);
          setInAirport(false);

          if (response[0] && response[0].matched && response[0].pricing) {
            setOutPricing(response[0].pricing);
            setOutAirport(response[0].is_airport);
            setOutAvailable(true);
          }
          if (response[1] && response[1].matched && response[1].pricing) {
            setInPricing(response[1].pricing);
            setInAirport(response[1].is_airport);
            setInAvailable(true);
          }

          let customMessage = null;
          if (response[0] && response[0].custom_location && response[0].custom_message) {
            customMessage = response[0].custom_message;
          } else if (response[1] && response[1].custom_location && response[1].custom_message) {
            customMessage = response[1].custom_message;
          }
          setCustomErrorMessage(customMessage);

          setDateSearching(false);
          setTotal(null);

          setUpBooking(false);
        }
      });
    }
  }

  const validatePostData = (strict) => {
    let valid = true;
    if (!selectedOutbound && (bookingType === RETURN_TRIP && !selectedInbound)) {
      valid = false;
      console.log('E1')
    }

    if (strict) {
      if (!selectedOutbound) {
        valid = false;
        console.log('E2')
      }
      if (bookingType === RETURN_TRIP && !selectedInbound) {
        valid = false;
        console.log('E3')
      }

      if (!fullName) {
        valid = false;
        console.log('E4')
      }
      if (!phone) {
        valid = false;
        console.log('E5')
      }
      if (!email) {
        valid = false;
        console.log('E6')
      }
      if (outAirport && !outNoFlight && (!outAirline || !outFlightTime || !outFlightNumber)) {
        valid = false;
        console.log('E7')
      }
      if (bookingType === RETURN_TRIP && !inNoFlight && inAirport && (!inAirline || !inFlightTime || !inFlightNumber)) {
        valid = false;
        console.log('E8')
      }
    }

    const outPaxValidate = validatePax(outPax);
    if (!outPaxValidate[0]) {
      valid = false;
      setOutPaxError(outPaxValidate[1]);
      console.log('E9')
    } else {
      setOutPaxError(null);
    }

    if (bookingType === RETURN_TRIP) {
      const inPaxValidate = validatePax(inPax);
      if (!inPaxValidate[0]) {
        valid = false;
        setInPaxError(inPaxValidate[1]);
        console.log('E10')
      } else {
        setInPaxError(null);
      }
    }

    return valid;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setFinalSubmitting(true);
    setUpBooking(true);

    const params = [];
    params[TRIP_PICKUP] = outStartAddress;
    params[TRIP_DROPOFF] = outEndAddress;
    params[TRIP_PAX] = participantString(outPax);
    params[TRIP_DATE] = outDate;
    params[TRIP_TERMINAL] = outTerminal;

    params[TRIP_RETURN_PICKUP] = inStartAddress;
    params[TRIP_RETURN_DROPOFF] = inEndAddress;
    params[TRIP_RETURN_PAX] = participantString(inPax);
    params[TRIP_RETURN_DATE] = inDate;
    params[TRIP_RETURN_TERMINAL] = inTerminal;

    params[PAX_NAME] = fullName;
    params[PAX_EMAIL] = email;
    params[PAX_PHONE] = phone;
    params[TRIP_TOTAL] = total;


    dataLayerHandler(TRIP_SUBMIT, params);
  }

  const handleSaveDraft = (e) => {
    e.preventDefault();

    const params = [];
    params[TRIP_PICKUP] = outStartAddress;
    params[TRIP_DROPOFF] = outEndAddress;
    params[TRIP_PAX] = participantString(outPax);
    params[TRIP_DATE] = outDate;
    params[TRIP_TERMINAL] = outTerminal;

    params[TRIP_RETURN_PICKUP] = inStartAddress;
    params[TRIP_RETURN_DROPOFF] = inEndAddress;
    params[TRIP_RETURN_PAX] = participantString(inPax);
    params[TRIP_RETURN_DATE] = inDate;
    params[TRIP_RETURN_TERMINAL] = inTerminal;

    params[PAX_NAME] = fullName;
    params[PAX_EMAIL] = email;
    params[PAX_PHONE] = phone;
    dataLayerHandler(TRIP_SAVE_DRAFT, params);

    apiPost(ENDPOINT_SAVE_DRAFT).then((response) => {
      window.location = response.redirect
    });
  }

  const setUpBooking = (submit) => {
    const valid = validatePostData(submit);
    if (valid) {

      const post = {
        type: bookingType,
        outward: null,
        inward: null
      }

      if (submit) {
        post.fullName = fullName;
        post.email = email;
        post.phone = phone;
        post.notes = passengers;
        post.final_step = true;
        post.promo = promo;

        if (configs.agent) {
          post.voucher = voucher;
          post.company = company;
        }
      }

      if (outStartLat && outEndLng && outPax && outDate && selectedOutbound) {
        setOutSelectionLoading(selectedOutbound.activity);
        post.outward = {
          start: [outStartLng, outStartLat, outStartAddress],
          end: [outEndLng, outEndLat, outEndAddress],
          date: outDate,
          pax: outPax,
          activity: selectedOutbound.activity,
          timeId: selectedOutbound.timeId,
          extras: selectedOutbound.extras,
          is_airport: outAirport,
          airline: !outNoFlight ? outAirline : '',
          flight_number: !outNoFlight ? outFlightNumber : '',
          flight_time: !outNoFlight ? outFlightTime : '',
          terminal: outTerminal
        }
      }

      if (bookingType === RETURN_TRIP && inStartLat && inEndLng && inPax && inDate && selectedInbound) {
        setInSelectionLoading(selectedInbound.activity);
        post.inward = {
          start: [inStartLng, inStartLat, inStartAddress],
          end: [inEndLng, inEndLat, inEndAddress],
          date: inDate,
          pax: inPax,
          activity: selectedInbound.activity,
          timeId: selectedInbound.timeId,
          extras: selectedInbound.extras,
          is_airport: inAirport,
          airline: !outNoFlight ? inAirline : '',
          flight_number: !outNoFlight ? inFlightNumber : '',
          flight_time: !outNoFlight ? inFlightTime : '',
          terminal: inTerminal
        }
      }

      setCanSubmit(false);
      if (post.inward || post.outward) {
        setPriceSearching(true);
        apiPost(
          ENDPOINT_BOOKING_SETUP,
          post,
          undefined,
          handleAbortController()
        ).then((response) => {
          setTotal(response.total);
          setLateFee(response.late_fee);
          setPriceSearching(false);
          setOutSelectionLoading(null);
          setInSelectionLoading(null);
          setFinalSubmitting(false);
          calculateCanSubmit();
          if (submit && response.link) {
            window.location = response.link;
          }
        });
      }
    }
  }

  const calculateCanSubmit = () => {
    console.log('CALCULATE', bookingType, selectedInbound, selectedOutbound);
    setCanSubmit(
        (
          bookingType === RETURN_TRIP
            ? selectedInbound && selectedOutbound
            : selectedOutbound
        )
    );
  }

  const applyPromoCode = () => {
    if (promo) {
      setPromoApplying(true);
      setPriceSearching(true);
      apiPost(
        ENDPOINT_PROMO_CODE,
        {
          promo: promo
        },
        undefined,
        handleAbortController()
      ).then((response) => {
        setTotal(response.total);
        setPriceSearching(false);
        setPromoApplying(false);
      });
    }
  }

  const showUnAvailable = () => {
    return customErrorMessage === null
      && (
        outAvailable === false
        || (bookingType === RETURN_TRIP && inAvailable === false)
      );
  }

  const isTripsAvailable = () => {
    return true; // TODO:
    return outAvailable
      && customErrorMessage === null
      && (bookingType !== RETURN_TRIP || ((bookingType === RETURN_TRIP && inAvailable)))
  }

  if (loading) {
    return <div className="booking bookingPage">
      <div className="container">
        <div className="booking__wrap">
          <Loading />
        </div>
      </div>
    </div>
  }

  return <GoogleMapsAPILoader>
    <form onSubmit={handleSubmit}>
      <div className="booking bookingPage">
        <div className="container">
          <div className="booking__wrap">
            <TripSection
              tripType={OUTWARD}
              bookingType={bookingType}
              startAddress={outStartAddress}
              endAddress={outEndAddress}
              airlines={configs.airlines}
              pax={outPax}
              date={outDate}
              showTerminal={outAirport}
              airport={outAirport}
              airline={outAirline}
              noFlight={outNoFlight}
              flightNumber={outFlightNumber}
              flightTime={outFlightTime}
              terminal={outTerminal}
              paxError={outPaxError}
              setStartLat={setOutStartLat}
              setStartLng={setOutStartLng}
              setStartAddress={(v) => { dataLayerHandler(TRIP_PICKUP, v); setOutStartAddress(v); }}
              setEndLat={setOutEndLat}
              setEndLng={setOutEndLng}
              setEndAddress={(v) => { dataLayerHandler(TRIP_DROPOFF, v); setOutEndAddress(v); }}
              setPax={(v) => { dataLayerHandler(TRIP_PAX, participantString(v)); setOutPax(v); }}
              setDate={(v) => { dataLayerHandler(TRIP_PAX, v); setOutDate(v); }}
              setBookingType={updateBookingType}
              setAirport={setInAirport}
              setAirline={setOutAirline}
              setFlightNumber={setOutFlightNumber}
              setFlightTime={setOutFlightTime}
              setNoFlight={setOutNoFlight}
              setTerminal={setOutTerminal}
              isUnavailable={showUnAvailable()}
            />

            {bookingType === RETURN_TRIP && <>
              <TripSection
                tripType={INBOUND}
                bookingType={bookingType}
                startAddress={inStartAddress}
                endAddress={inEndAddress}
                airlines={configs.airlines}
                pax={inPax}
                outDate={outDate}
                date={inDate}
                showTerminal={inAirport}
                airport={inAirport}
                airline={inAirline}
                noFlight={inNoFlight}
                flightNumber={inFlightNumber}
                flightTime={inFlightTime}
                terminal={inTerminal}
                paxError={inPaxError}
                setStartLat={setInStartLat}
                setStartLng={setInStartLng}
                setStartAddress={(v) => { dataLayerHandler(TRIP_RETURN_PICKUP, v); setInStartAddress(v); }}
                setEndLat={setInEndLat}
                setEndLng={setInEndLng}
                setEndAddress={(v) => { dataLayerHandler(TRIP_RETURN_DROPOFF, v); setInEndAddress(v); }}
                setPax={(v) => { dataLayerHandler(TRIP_RETURN_PAX, participantString(v)); setInPax(v); }}
                setDate={(v) => { dataLayerHandler(TRIP_RETURN_DATE, v); setInDate(v); }}
                setBookingType={updateBookingType}
                setAirport={setInAirline}
                setAirline={setInAirline}
                setFlightNumber={setInFlightNumber}
                setFlightTime={setInFlightTime}
                setNoFlight={setInNoFlight}
                setTerminal={setInTerminal}
                isUnavailable={showUnAvailable()}
              />
            </>}


            {dateSearching && <div className={'booking__searching'}>
              <h3>
                We are just gathering the available shuttles for your request. <br />
                This might take a minute. Thank you for your patience!
              </h3>
              <Loading />
            </div>}

            {(customErrorMessage) && <>
              <div className="booking__getQuote__submitted booking__getQuote__request">
              <div
                className="submitted__left"
                dangerouslySetInnerHTML={{__html: customErrorMessage}}
              />
            </div>
            </>}

            {(showUnAvailable()) && <>
              <div className="booking__getQuote__submitted booking__getQuote__request">
              <div
                className="submitted__left"
                dangerouslySetInnerHTML={{__html: configs.bookingError}}
              />
              <div className="submitted__right">
                <a href={configs.quotePage} className="btn btn--lg">
                  Book a Private Shuttle
                </a>
              </div>
            </div>
            </>}

            {(isTripsAvailable()) && <>
              {!dateSearching && <>
                {(outPricing && outPricing.length) && <>
                  <TripSelector
                    type={OUTWARD}
                    options={outPricing}
                    selection={selectedOutbound}
                    onSelect={(v, option) => {
                      setSelectedOutbound(v);
                      dataLayerHandler(TRIP_SELECT, {
                        transfer: option.name,
                      });
                    }}
                    loader={outSelectionLoading}
                  />
                </>}
                {(bookingType === RETURN_TRIP && inPricing && inPricing.length) && <>
                  <TripSelector
                    type={INBOUND}
                    options={inPricing}
                    selection={selectedInbound}
                    onSelect={(v, option) => {
                      setSelectedInbound(v);
                      dataLayerHandler(TRIP_RETURN_SELECT, {
                        transfer: option.name
                      });
                    }}
                    loader={inSelectionLoading}
                  />
                </>}

                <div className="booking__section">
                  <div className="booking__yourDetail">
                    <div className="booking__title booking__yourDetail__title">
                      <div className="booking__headIcon">
                        <IconHeading />
                      </div>
                      <h3>Your Details</h3>
                    </div>
                  </div>
                  <div className="booking__yourDetail__inputs booking__section__inputs">
                    <div className="booking__yourDetail__input booking__section__input">
                      <label>Full name</label>
                      <input
                        type="text"
                        aria-labelledby="name"
                        required={true}
                        placeholder="Enter full name"
                        value={fullName}
                        onChange={(e) => {
                          setFullName(e.target.value);
                        }}
                        onBlur={(e) => {
                          dataLayerHandler(PAX_NAME, e.target.value);
                        }}
                      />
                    </div>
                    <div className="booking__yourDetail__input booking__section__input">
                      <label>Email</label>
                      <input
                        type="email"
                        aria-labelledby="email"
                        required={true}
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        onBlur={(e) => {
                          dataLayerHandler(PAX_EMAIL, e.target.value);
                        }}
                        placeholder="Enter email address" />
                    </div>
                    <div className="booking__yourDetail__input booking__section__input">
                      <label>Phone</label>
                      <input
                        type="text"
                        aria-labelledby="phone"
                        required={true}
                        value={phone}
                        onChange={(e) => {
                          setPhone(e.target.value);
                        }}
                        onBlur={(e) => {
                          dataLayerHandler(PAX_PHONE, e.target.value);
                        }}
                        placeholder="Enter phone number" />
                    </div>
                  </div>
                </div>

                {(!dateSearching && selectedOutbound && (bookingType !== RETURN_TRIP || selectedInbound)) && <>
                  <ExtraRequirements
                    bookingType={bookingType}
                    outbound={selectedOutbound}
                    inbound={selectedInbound}
                    setOutbound={setSelectedOutbound}
                    setInbound={setSelectedInbound}
                  />
                </>}

                {!!configs.agent && <div className="booking__section">
                  <div className="booking__passengerDetail">
                    <div className="booking__title">
                      <div className="booking__headIcon">
                        <IconHeading />
                      </div>
                      <h3>Passenger Details/Notes</h3>
                    </div>
                  </div>
                  <div className="booking__passengerDetail__inputs booking__section__inputs">
                    <div className="booking__passengerDetail__input booking__section__input">
                      {/*<label>Passengers</label>*/}
                      <textarea
                        value={passengers}
                        onChange={(e) => { setPassengers(e.target.value) }}
                        placeholder="Enter notes/passenger names" />
                    </div>
                  </div>
                </div>}

                {!!configs.agent && <div className="booking__section">
                  <div className="booking__passengerDetail">
                    <div className="booking__title">
                      <div className="booking__headIcon">
                        <IconHeading />
                      </div>
                      <h3>Payment/Voucher Details</h3>
                    </div>
                  </div>

                  <div className="booking__yourDetail__inputs booking__section__inputs">
                    {/*<div className="booking__yourDetail__input booking__section__input input--half">*/}
                    {/*  <label>Company Name</label>*/}
                    {/*  <input*/}
                    {/*    type="text"*/}
                    {/*    aria-labelledBy="Company"*/}
                    {/*    required={true}*/}
                    {/*    placeholder="Enter Company name"*/}
                    {/*    value={company}*/}
                    {/*    onChange={(e) => {*/}
                    {/*      setCompany(e.target.value)*/}
                    {/*    }}*/}
                    {/*  />*/}
                    {/*</div>*/}
                    <div className="booking__yourDetail__input booking__section__input input--half">
                      <label>Voucher Reference</label>
                      <input
                        type="text"
                        aria-labelledby="Voucher Reference"
                        required={true}
                        value={voucher}
                        onChange={(e) => {
                          setVoucher(e.target.value)
                        }}
                        placeholder="Enter Voucher Reference" />
                    </div>
                  </div>
                </div>}


                <div className="booking__section booking__promocode">
                  <div className="booking__passengerDetail">
                    <div className="booking__title booking__noMargin">
                      <div className="booking__headIcon">
                        <IconHeading />
                      </div>
                      <h3>Promo Code</h3>
                    </div>
                  </div>
                  <div className="booking__passengerDetail__inputs booking__section__inputs">
                    <div className="booking__promocode__wrap">
                      <div className="booking__promocode__input">
                        <input
                          type="text"
                          aria-labelledby="promocode"
                          value={promo}
                          onChange={(e) => {
                            setPromo(e.target.value)
                          }}
                          placeholder="" />
                      </div>
                      <div className="booking__promocode__apply">
                        <button
                          disabled={priceSearching || promoApplying}
                          type={'button'}
                          name={''}
                          onClick={applyPromoCode}
                          className={'btn btn--sm'}>
                          {promoApplying ? <Loading /> : 'Apply'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="booking__section">
                  <div className="booking__total">
                    <div className="booking__total__left typography">
                      <p className="h3">Total Including taxes and charges</p>
                      {!!lateFee && <p>
                        Bookings made less than 48 hours in advance incur an additional fee.
                        This covers the costs of last-minute schedule adjustments and ensures we maintain service quality for all customers.<br />
                        To avoid this fee, please book at least 48 hours before your desired service time.
                      </p>}
                      {/*{!!lateFee && <p><i>A late booking fee of {lateFee} applied</i></p>}*/}
                    </div>
                    <div className="booking__total__right typography">
                      <p className="h2">{`NZD ${moneyFormat(total)}`}</p>
                    </div>
                  </div>
                </div>
                <div className="booking__confirm">
                  <button
                    onClick={handleSaveDraft}
                    disabled={priceSearching || !canSubmit}
                    type={'button'}
                    name={''}
                    className={'btn btn--lg'}
                  >SAVE DRAFT</button>
                  <button
                    disabled={priceSearching || !canSubmit}
                    type={'submit'}
                    name={'confirm'}
                    className="btn btn--lg btn--lg">
                      {(finalSubmitting) ? <Loading /> : 'CONFIRM BOOKING'}
                  </button>
                </div>
              </>}
            </>}
          </div>
        </div>
      </div>
    </form>
  </GoogleMapsAPILoader>;
};

export default BookingPage;
